<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<!-- <div style="background-color: #fff;border-radius: 10px;padding: 20px;margin-bottom: 20px;font-size: 16px;font-weight: bold;margin-top: 20px;">一分一段</div> -->
		<div class="boxA">
			<!-- <div class="box-tit"><span>一分一段</span></div> -->
			<div class="box-tit">
				<span>{{videoName.courseName}}</span>
			</div>
			<!-- <div class="search-t">
				<el-input  placeholder="请输入院校名称" v-model="queryParams.schoolName"  class="input-with-select" clearable>
					<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
				</el-input>
			</div> -->
		</div>
		
		
		<div class="schmain">
			<!-- @error="videoErrorCallback" -->
			<!-- @timeupdate="videoTimeUpdateEvent($event)" -->
			<video v-if="showVideo" :src="UPLODE_URL+videoName.courseUrl" style="width:100%" controls  :custom-cache="false" autoplay id="myVideo" ref="myVideo" ></video>
			
		</div>
		
		
		
		
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
    
  </div>
</template>

<script>
import { xuemengintro } from "@/api/intoxuemeng";
	import  {UPLODE_URL} from '@/utils/request'
	import { EventBus } from '@/utils/event-bus.js';
export default {
  data() {
    return {
		UPLODE_URL,
		token: localStorage.getItem('token')||'',
		user:JSON.parse(localStorage.getItem('user'))||'',
	    videoName:{},
		showVideo: true, // 控制视频的显示与隐藏
    };
  },
 
  created() {
  },
  mounted() {
  	
	 this.token= localStorage.getItem('token')||''
	 this.user=JSON.parse(localStorage.getItem('user'))||''
	 this.videoName=JSON.parse(localStorage.getItem('videoInfo'))
  },
  beforeDestroy() {
	  this.showVideo = false
	  if (this.$refs.myVideo) {
	      this.$refs.myVideo.pause();
	    }
      this.stopVideo();
    },
 
  methods: {
	stopVideo() {
	     console.log('zzzzzzz')  
		 
		 this.showVideo = false
	}
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		border-radius: 10px;
		    padding: 10px 10px 0px 10px;
		    margin-top: 10px;
		// .box-tit{
		// 	width: 100%;
		// 	height: 40px;
		// 	line-height: 40px;
		// 	border-bottom: 1px solid #F44F4D;
		// 	margin-bottom: 15px;
		// 	span{
		// 		width: 140px;
		// 		height: 40px;
		// 		line-height: 40px;
		// 		background-color: #F44F4D;
		// 		color: #fff;
		// 		display: block;
		// 		border-radius: 10px 10px 0 0;
		// 		text-align: center;
		// 		font-size: 15px;
		// 	}
		// }
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			display: flex;
			span{
				
				height: 40px;
				line-height: 40px;
				cursor: pointer;
				display: block;
				text-align: center;
				font-size: 16px;
				font-weight: bold;
			}
			span.onsele{
				background-color: #F44F4D;
				color: #fff;
				border-radius: 10px 10px 0 0;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 30%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	}
	
	// <div class="schmain">
	// 	<div class="sch-ul">
	// 		<div class="sch-li">
	// 			<div class="schli-l"><img src="../../assets/1.png" alt="" /></div>
	// 			<div class="schli-r">
	// 				<div class="schli-rt"><span class="schli-rt-a">天津大学</span><span class="schli-rt-b">dizhi</span></div>
	// 				<div class="schli-rb"><span>benke </span></div>
	// 			</div>
	// 		</div>
	// 	</div>
	// </div>
	.schmain{
		    margin-top: 12px;
		    padding: 10px;
		    border-radius: 10px;
			min-height: 80vh;
		.sch-ul{
			.sch-li:hover{
				.schli-rt-a{
					color: #F44F4D;
				}
			}
			.sch-li{
				
				background: #fff;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				padding: 20px;
				border-radius: 10px;
				cursor: pointer;
				.schli-l{
					width: 120px;
					height: 90px;
					margin-right: 20px;
					position: relative;
					img{
						width: 120px;
						height: 90px;
						border-radius: 10px;
					}
					.pay{
						position: absolute;
						background: rgba(4, 4, 4, 0.3);
						border-radius: 10px;
						left: 0;
						right: 0;
						bottom: 0;
						top: 0;
						display: flex;
						justify-content: center;
					}
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						display: flex;
						align-items: center;
						margin-bottom: 10px;
						.schli-rt-a{
							font-size: 22px;
						}
						.schli-rt-b{
							margin-left: 10px;
							    height: 25px;
								line-height: 25px;
							    border-radius: 26px;
							    border: 1px solid #d8d8d8;
							    padding: 0 10px;
							    font-size: 12px;
							    color: #666;
						}
					}
					.schli-rb{
						margin-top: 6px;
						span{
							    height: 22px;
							    padding: 0 8px;
							    border-radius: 4px;
							    background: #f5f6f7;
							    font-size: 14px;
							    color: #666;
							    margin-right: 8px;
						}
					}
				}
			}
		}
	}
}
.admit-scoreLine-box-table-th{
				margin-bottom: 10px;
			}
			.admit-scoreLine-box-table-list{
				width: 100%;
				display: flex;
				.admit-scoreLine-box-table-list-div{
					flex: 1;
					// margin-bottom: 6px;
					text-align: center;
					line-height: 40px;
					    border-bottom: 1px solid #f0f0f0;
				}
				
			}
.admit-scoreLine-box-table-th-div{
	font-size: 14px;
	text-align: center;
}
</style>